import NoDataImg from "../../Assets/Images/no-data-img.png"
import React from "react"
import "./NoDataPrompt.css"
import { SyncLoader } from "react-spinners";

export default function NoDataPrompt() {
    return(
        <div className="no-data-cont">
            {/* <img src={NoDataImg} alt="no data found" /> */}
            <span>No data found.</span>
            {/* <SyncLoader color="var(--primary-color)" size={20} /> */}
        </div>
    )
}